import {useCallback} from 'react';

import type {AlertButton, ViewProps} from './types';

import {alert} from '../../containers/AlertContainer/alertApi';

export const useController = ({
  onAwaitableDismiss,
  onDismiss,
  resolve,
}: ViewProps) => {
  const onButtonClick = useCallback(
    (button: AlertButton) => {
      const resolveWrapper = (value: unknown) => {
        resolve(value);

        if (button.hideAlertOnClick !== false) {
          alert.hide();
        }
      };

      if (button.onAwaitableClick) {
        button.onAwaitableClick(resolveWrapper);
      } else {
        button.onClick?.();

        resolveWrapper(undefined);
      }
    },
    [resolve],
  );

  const onCloseButtonClick = useCallback(() => {
    const resolveWrapper = (value: unknown) => {
      resolve(value);

      alert.hide();
    };

    if (onAwaitableDismiss) {
      onAwaitableDismiss(resolveWrapper);
    } else {
      onDismiss?.();

      resolveWrapper(undefined);
    }
  }, [onAwaitableDismiss, onDismiss, resolve]);

  return {onButtonClick, onCloseButtonClick};
};
